import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import Recaptcha from 'react-recaptcha'
import RaisedButton from 'material-ui/RaisedButton';
import s from '../../services/allservices.jsx'
import '../../stylesheet/contactus.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import services from '../../services/allservices.jsx'
import * as actions from '../../actions/actions.jsx'
import { connect } from 'react-redux'
import {
    withRouter
} from 'react-router-dom';
// import kapcha from '../../images/Kaptcha.jpg'
import LoaderSmall from "../loader/loadersmall.jsx"


const mapStateToProps = state =>
    ({
        contactUsSubjectState: state.contactUsSubjectReducer.contactUsSubjectState,
    })
const mapDispatchToProps = dispatch =>
    ({
        getContactSubject() {
            dispatch(
                actions.contactSubjectAction()
            )
        }
    })

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};


var callback = function () {

}


// specifying verify callback function


// specifying verify callback function
// var verifyCallback = function (response) {

//     let state = {
//         "g-recaptcha-response": response
//     }

//     fetch(s.capcha, {
//         method: "POST",
//         headers: {
//             'content-type': 'application/json'
//         },
//         body: { "g-recaptcha-response": response }
//     })
//         .then(res => {

//         })
// };

class ContactUsComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            capcha: '',
            response: "",
            firstName: "",
            lastName: "",
            comments: "",
            emailId: "",
            correctphone: true,
            correctcomm: true,
            subject: 1,
            disabled: true,
            correctEmail: true,
            mobileNumber: "",
            contactUsSubjectState: [],
            cardDetailsId: ""

        }
        // this.handleCapcha = this.handleCapcha.bind(this)
    }
    handleSelect = (event, index, value) => this.setState({ subject: value });

    componentDidMount() {
        this.props.getContactSubject()
    }

    handleChange = (e, value) => {

        if (e.target.name === "firstName" || e.target.name === "lastName" || e.target.name === "comments" || e.target.name === "emailId" || e.target.name === "subject" || e.target.name === "mobileNumber") {

            if (e.target.name === "emailId") {
                if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(e.target.value)) {
                    this.setState({
                        correctEmail: true,
                        emailId: value,
                        disabled: false,
                    })
                } else {
                    this.setState({
                        correctEmail: false,
                        disabled: true,
                    })
                }
            }

            if (e.target.name === "mobileNumber") {
                if (/^[0-9]{8,15}$/.test(e.target.value)) {
                    this.setState({
                        correctphone: true,
                        mobileNumber: value,
                        disabled: false,
                    })
                } else {
                    this.setState({
                        correctphone: false,
                        disabled: true,
                    })
                }
            }

            this.setState({
                [e.target.name]: e.target.value
            }, () => {

                const { firstName, lastName, comments, subject, emailId, mobileNumber } = this.state

                if (firstName !== "" && lastName !== "" && comments !== "" && subject !== "" && emailId !== "" && mobileNumber !== "") {

                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }

    }

    verifyCallback = response => {
        this.setState({
            response: response

        }, () => {

        })
    }

    handleSubmit = () => {
        const { response, correctEmail, correctphone } = this.state
        if (correctEmail === false) {
            this.setState({
                correctEmail: false
            })
        }
        else if (correctphone === false) {
            this.setState({
                correctphone: false
            })
        }
        else {

            let _this = this
            if (response !== '') {
                const state = {
                    firstName: _this.state.firstName,
                    lastName: _this.state.lastName,
                    comments: _this.state.comments,
                    emailId: _this.state.emailId,
                    subject: _this.state.subject,
                    mobileNumber: _this.state.mobileNumber,
                    cardDetailsId: " "
                }


                this.setState({
                    loader: true
                })

                fetch(s.contact_us + "/?g-recaptcha-response=" + response, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify(state)
                })
                    .then(res => {
                        if (res.status === 200 || res.status === 201) {
                            toast.success(res.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            this.setState({
                                loader: false
                            })
                            setTimeout(function () {
                                window.location.reload(1);
                            }, 3000);

                        } else {

                            toast.error(res.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });


                        }
                    })
            }
        }
    }

    // verifyCallback = response => {

    //     this.setState({
    //         "g-recaptcha-response": response
    //     }, () => {
    //         let state = {
    //             "response": response
    //         }
    //         fetch(s.capcha + "/?g-recaptcha-response=" + response, {
    //             method: "POST",
    //             headers: {
    //                 'content-type': 'application/json'
    //             },
    //             body: JSON.stringify(state)
    //         })
    //             .then(res => {

    //             })
    //     })


    // }
    render() {
        const { correctEmail, correctphone } = this.state
        const { contactUsSubjectState } = this.props
        return (
            <div className="col-sm-12">
                <div className="row" style={{ padding: "0 15px" }}>
                    <ToastContainer
                        draggablePercent={60}
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable={false}
                        pauseOnHover
                    />

                    <div className="col-sm-12 contactus">
                        <div className="row" >
                            <div className="col-sm-12 bg-white" style={{ padding: "15px 20px" }}>
                                <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <h2>Contact Us</h2>
                                    </div>
                                </div>
                                <div className="row input-group" >
                                    <div className="offset-md-1 col-sm-5">
                                        <div className="row">
                                            <div className="col-sm-2 input-icon" >
                                                <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-8" >
                                                <TextField
                                                    hintText="Type Your First Name"
                                                    floatingLabelText="First Name"
                                                    type="text"
                                                    name="firstName"
                                                    maxLength="30"
                                                    className="input-width required"
                                                    onChange={this.handleChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle} />

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-sm-5">
                                        <div className="row">
                                            <div className="col-sm-2 input-icon" >
                                                <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-8" >
                                                <TextField
                                                    hintText="Type Your Last Name"
                                                    floatingLabelText="Last Name"
                                                    type="text"
                                                    htmlFor="choose"
                                                    name="lastName"
                                                    maxLength="30"
                                                    className="input-width required"
                                                    onChange={this.handleChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row input-group" >
                                    <div className="offset-md-1 col-sm-5">
                                        <div className="row">
                                            <div className="col-sm-2 conemailinput" >
                                                <i className="fa fa-envelope text-dark " aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-8" >
                                                <TextField
                                                    hintText="Start Typing"
                                                    floatingLabelText="E-Mail"
                                                    type="text"
                                                    name="emailId"
                                                    maxLength="50"
                                                    className="input-width required"
                                                    onChange={this.handleChange}

                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                    errorText={correctEmail ? null : "Not a valid email"}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-sm-6 nopadding">
                                        <div className="row input-group" >
                                            <div className="col-sm-2 input-icon" >
                                                <i className="fa fa-thumb-tack" aria-hidden="true"></i>
                                            </div>
                                            <div className="col-sm-10" >
                                                <SelectField
                                                    floatingLabelText="Select Subject"
                                                    value={this.state.subject}
                                                    className="required"
                                                    onChange={this.handleSelect}
                                                    name="subject"
                                                >
                                                    {/* <MenuItem value={1} primaryText="Card Issues And Questions" />
                                                    <MenuItem value={2} primaryText="Others" /> */}
                                                     {(this.props.contactUsSubjectState.length !== 0 && this.props.contactUsSubjectState.status === 200) ?
                                                         this.props.contactUsSubjectState.body && this.props.contactUsSubjectState.body.map((value, i) =>
                                                           <MenuItem value={(JSON.parse(this.props.contactUsSubjectState.body[i].subjectId))} primaryText={contactUsSubjectState.body[i].description} />
                                                      )
                                                      :
                                                     <div></div>
                                                    }
                                                </SelectField>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="row input-group" >
                                        <div className="offset-md-1 col-sm-5">

                                            <div className="row">
                                                <div className="col-sm-2 conemailinput" >
                                                    <i className="fa fa-mobile text-dark " aria-hidden="true"></i>
                                                </div>
                                                <div className="col-sm-8" >

                                                    <TextField
                                                        hintText="Enter Mobile Number"
                                                        floatingLabelText="Mobile Number"
                                                        type="number" step="1"
                                                        name="mobileNumber"
                                                        maxLength="15"
                                                        onInput={(e) => {
                                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                                                        }}
                                                        className="input-width required"
                                                        onChange={this.handleChange}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        errorText={correctphone ? null : "Not a valid phone number"} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="row">
                                                <div className="col-sm-2 input-icon" >
                                                    <i className="fa fa-comment text-dark " aria-hidden="true"></i>
                                                </div>
                                                <div className="col-sm-8" >
                                                    <TextField
                                                        hintText="Write Your Comment"
                                                        floatingLabelText="Comments"
                                                        multiLine={true}
                                                        className="input-width required"
                                                        name="comments"
                                                        rows={1}

                                                        onChange={this.handleChange}
                                                        maxLength="1000"
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="offset-md-4 col-sm-5">
                                        <div className="row">
                                            <div className="col-sm-12 text-center margin-capcha">
                                                <Recaptcha
                                                    sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                                    render="explicit"
                                                    verifyCallback={this.verifyCallback}
                                                    onloadCallback={callback}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="offset-sm-4 col-sm-3">
                                        <RaisedButton
                                            label="Submit"
                                            className="pull-right"
                                            // style={styles.button}
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            id="submit"
                                            disabled={this.state.disabled}
                                            onClick={this.handleSubmit}
                                            style={{ marginTop: "10px" }}
                                        />
                                    </div>{this.state.loader === true &&
                                        <div className="col-sm-1" style={{ marginTop: "-17px", width: "30% !mportant" }} >
                                            <LoaderSmall />
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
const ContactUs = connect(mapStateToProps, mapDispatchToProps)(ContactUsComp)
export default withRouter(ContactUs);



// WEBPACK FOOTER //
// ./src/components/contactus/contactus.jsx